<template>
    <b-nav vertical>
        <div 
            v-for="rootItem in localMenu" 
            :key="rootItem.key" 
            :class="[`sidebar-section-${rootItem.key}`, {'active': expandedItemKeys.includes(rootItem.key) || activeItemKeys.includes(rootItem.key)}]" 
            class="sidebar-section"
        >
            <b-nav-item 
                :active="expandedItemKeys.includes(rootItem.key) || activeItemKeys.includes(rootItem.key)" 
                :href="rootItem.link ? rootItem.link.href : null"
                v-b-toggle="rootItem.disabled ? null : childCollapsePrefix + rootItem.key"
                :disabled="rootItem.disabled"
                class="mb-0 nav-level-1" 
                :class="[`nav-item-internal-key-${rootItem.key}`]"
                link-classes="d-flex justify-content-between align-items-center"
            >  <!-- v-bind="rootItem.rootNavItemAttrs" -->
                <div class="d-flex align-items-center">
                    <b-icon 
                        v-if="rootItem.icon && rootItem.icon.tag == 'b-icon'" 
                        :icon="rootItem.icon.attrs.icon" 
                        class="mr-3 main-icon" 
                        font-scale="1.8"
                    ></b-icon>
                    {{ rootItem.label }}
                </div>
                <div v-if="Array.isArray(rootItem.children) && rootItem.children.length" class="collapse-toggle-icon">
                    <b-icon icon="chevron-up" class="when-open"></b-icon>
                    <b-icon icon="chevron-down" class="when-closed"></b-icon>
                </div>
            </b-nav-item>
            <b-collapse 
                v-if="Array.isArray(rootItem.children) && rootItem.children.length"
                :visible="expandedItemKeys.includes(rootItem.key)"
                :id="childCollapsePrefix + rootItem.key"
            >  <!-- :visible="expandedItemKeys.includes(rootItem.key)"  -->
                <b-nav vertical class="subnav-group">
                    <b-nav-item 
                        v-for="childItem in rootItem.children"
                        :key="childItem.key"
                        :active="activeItemKeys.includes(childItem.key)"
                        :disabled="childItem.disabled"
                        :href="childItem.link ? childItem.link.href : null"
                        :class="[`nav-item-internal-key-${childItem.key}`]"
                    >
                        {{ childItem.label }}
                    </b-nav-item>
                </b-nav>
            </b-collapse>
        </div>
    </b-nav>
</template>

<script>
//import cloneDeep from 'lodash/cloneDeep';

// on top-level groups, we set css class 'active' to expand the collapse (if a parent) and/or highlight the item if a link itself
/* 
schema for each item:
- label: string
- key: string
- level: int, root is 0
- icon: null or object with { tag: string, attrs: {}}
- link: null or object with { href: string, attrs: {}}
- children: null or array of items
*/

export default {
    name: 'InternalMenu',
    components: {},
    mixins: [],
    props: {
        menuJson: {  // NEW - pass a JSON string of the menu directly to prop
            type: String,
            required: false,
        },
    },  // can also get the menu from window object instead... both supported in this component for now...
    data() {
        return {
            localMenu: [],  // should always be an array
            itemStore: {},  // all menu items, keyed by key
            childCollapsePrefix: 'collapse-children-',
        }
    },
    computed: {
        currentUrlPath() {
            // get the current URL from the window object - will have leading and trailing slashes
            // NOTE - we could set this only in created() if we are not using front-end router... or better yet... use the router to get this?
            return window.location.pathname;
        },
        currentUrlPaths() {
            // get the current URL from the window object - will have leading and trailing slashes
            const exactPath = window.location.pathname;
            const paths = [exactPath];
            if (exactPath.length > 1 && exactPath.endsWith('/')) {
                paths.push(exactPath.slice(0, -1));
            }
            // add one without trailing slash?  and what about URLs at different domains? or with query params?
            return paths;
        },
        activeItemKeys() {
            // get the keys of the active items -- based on PREFIX MATCH -- could be more than one if multiple paths match based on prefix, and/or multiple exact matches
            const activeKeys = [];
            const activeItems = [];
            //let activeItem = null;
            const currentPaths = this.currentUrlPaths;
            for (const key in this.itemStore) {
                const item = this.itemStore[key];
                //if (item.link && currentPaths.includes(item.link.href)) {
                if (item.link && currentPaths.some((path) => path.startsWith(item.link.href))) {
                    activeKeys.push(key);
                    activeItems.push(item);
                    // then replace the activeItem if this one has longer (more specific) URL
                    // if (!activeItem || (item.link.href.length > activeItem.link.href.length)) {
                    //     activeItem = item;
                    // }
                }
            }
            // now, we may have multiple matches... the dashboard ('/') will match everything
            // we will return the key for LONGEST URL of all activeItems (string length)
            activeItems.sort((a, b) => {  // does an in-place sort
                return (b.link.href.length || 0) - (a.link.href.length || 0);
            });
            //console.log('activeItems:', activeItems);
            return activeItems.length ? [activeItems[0].key] : [];
            //return activeKeys.length ? [activeKeys[0]] : [];
            //return activeItem ? [activeItem.key] : [];
        },
        expandedItemKeys() {
            // just look at which one(s) are ACTIVE (after figuring all that out), then expand all of their parents
            const activeKeys = this.activeItemKeys;
            const expandedKeys = [];
            for (const key in this.itemStore) {
                const item = this.itemStore[key];
                if (Array.isArray(item.children) && item.children.length) {
                    item.children.forEach((child) => {
                        if (activeKeys.includes(child.key)) {
                            expandedKeys.push(item.key);
                        }
                    });
                }
            }
            return expandedKeys;
        },
        /* expandedItemKeys() {
            // get the keys of the expanded items -- should be one, but could be more
            const expandedKeys = [];
            const expandedItems = [];
            //let expandedItem = null;
            const currentPaths = this.currentUrlPaths;
            for (const key in this.itemStore) {
                const item = this.itemStore[key];
                // this works, but redundant and slow... could certainly optimize
                if (Array.isArray(item.children) && item.children.length) {
                    item.children.forEach((child) => {
                        //if (child.link && currentPaths.includes(child.link.href)) {
                        if (child.link && currentPaths.some((path) => path.startsWith(child.link.href))) {
                            expandedKeys.push(item.key);
                            expandedItems.push(item);
                            // then replace the activeItem if this one has longer (more specific) URL
                            // if (!expandedItem || (item.link.href.length > expandedItem.link.href.length)) {
                            //     expandedItem = item;
                            // }
                        }
                    });
                }
            }
            // now, we may have multiple matches... the dashboard ('/') will match everything
            // we will return the LONGEST URL of all expandedItems (string length)
            expandedItems.sort((a, b) => {  // does an in-place sort
                return (b.link.href.length || 0) - (a.link.href.length || 0);
            });
            return expandedItems.length ? [expandedItems[0].key] : [];
            // expandedKeys.sort((a, b) => b.length - a.length);  // in place sort 
            // return expandedKeys.length ? [expandedKeys[0]] : [];
            //return expandedItem ? [expandedItem.key] : [];
        }, */
    },
    created() {
        
    },
    mounted() {
        this.buildLocalMenu();
    },
    methods: {
        makeItemInst(itemObj) {
            // make a new item instance from the item object -- also register it in the itemStore
            // add attrs that we need to use in template v-bind 
            const isRoot = itemObj.level === 0;
            // pull off children so we can build them recursively 
            const { children, ...itemInst } = itemObj;
            // make sure we have a boolean set for `disabled`
            itemInst.disabled = !!itemInst.disabled;
            // make children recursively
            const hasChildren = children && Array.isArray(children) && children.length;
            if (hasChildren) {
                itemInst.children = children.map((child) => this.makeItemInst(child));
            }
            // add special stuff for root items 
            if (isRoot) {
                // make object to v-bind to root b-nav-item -- MAYBE NOT NEEDED
                const rootNavItemAttrs = {};
                if (itemObj.link?.href) {
                    rootNavItemAttrs.href = itemObj.link.href;
                }
                if (hasChildren) {
                    rootNavItemAttrs['v-b-toggle'] = this.childCollapsePrefix + itemObj.key;
                }
                itemInst.rootNavItemAttrs = rootNavItemAttrs;
            }
            // now register in item store
            this.itemStore[itemInst.key] = itemInst;
            return itemInst;
        },
        getRawMenuItems() {
            // NEW - get the data from menuJson prop if we have it!
            if (this.menuJson) {
                //console.log('GETTING INTERNAL MENU FROM menuJson PROP - raw JSON string:', this.menuJson);
                console.log('GETTING INTERNAL MENU FROM menuJson PROP');
                const fullMenuData = JSON.parse(this.menuJson);
                return fullMenuData.items || [];
            }
            console.log('GETTING INTERNAL MENU FROM window.internalMenuData');
            // get the raw menu items from the window object if not passed in as prop
            return window?.internalMenuData?.items || [];
        },
        buildLocalMenu() {
            // build the localMenu from menu prop
            //this.localMenu = JSON.parse(this.menuJson);
            const rawMenuItems = this.getRawMenuItems();
            //console.log('INTERNAL rawMenuItems:', rawMenuItems);
            // need to make this fully recursive if you support more than 1 level of nesting
            this.localMenu = rawMenuItems.map((item) => this.makeItemInst(item));
            // rawMenuItems.forEach((item) => {
            //     const itemInst = this.makeItemInst(item);  // also creates all children recursively
            //     this.itemStore[item.key] = itemInst;
            //     if (Array.isArray(itemInst.children) && itemInst.children.length) {
            //         itemInst.children.forEach((child) => {
            //             this.itemStore[child.key] = child;
            //         });
            //     }
            // });
        },
    },
}
</script>

<style lang="scss" scoped>
</style>